import { useState } from 'react';
import { ChatPanel, ChatMessage } from './ChatPanel';
import { ResultPanel } from './ResultPanel';
import { api, ReportResult } from '../../lib/api';
import { showToast } from '../../hooks/useToast';

interface AIResult extends ReportResult {
  sql: string;
  suggestedName: string;
}

export function AIBuilder() {
  const [messages, setMessages] = useState<ChatMessage[]>([]);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<AIResult | null>(null);

  const send = async (text: string) => {
    const nextMessages: ChatMessage[] = [...messages, { role: 'user', content: text }];
    setMessages(nextMessages);
    setLoading(true);
    try {
      const resp = await api.buildReport(nextMessages);
      if (resp.type === 'question') {
        setMessages([...nextMessages, { role: 'assistant', content: resp.question }]);
      } else if (resp.type === 'result') {
        setResult(resp);
        setMessages([
          ...nextMessages,
          { role: 'assistant', content: `Generated report: "${resp.suggestedName ?? 'custom report'}" — ${resp.meta.rowCount.toLocaleString()} rows in ${resp.meta.durationMs}ms.` },
        ]);
      } else if (resp.type === 'error') {
        showToast('error', resp.error);
        setMessages([...nextMessages, { role: 'assistant', content: `Query was blocked: ${resp.error}` }]);
      }
    } catch (err: any) {
      showToast('error', err.message ?? 'AI request failed');
      setMessages([...nextMessages, { role: 'assistant', content: `Error: ${err.message ?? 'Request failed'}` }]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid grid-cols-12 gap-3 h-[calc(100vh-100px)]">
      <div className="col-span-12 md:col-span-5 h-full min-h-0">
        <ChatPanel messages={messages} loading={loading} onSend={send} />
      </div>
      <div className="col-span-12 md:col-span-7 h-full min-h-0">
        <ResultPanel result={result} />
      </div>
    </div>
  );
}
